// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"6d2df6a21840f5c3f343660cc975458cb407933d"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;import * as Sentry from '@sentry/capacitor'

import { config } from '@/config'

import packageJson from '../../package.json'

/** @type {import('@sentry/capacitor').CapacitorOptions} */
const sentryOptions: Sentry.CapacitorOptions = {
  dsn: 'https://2b2c9947a30b4df79e3346d26f1050c3@o268566.ingest.sentry.io/5946968',
  tracesSampleRate: 1.0,
  release: packageJson.version,
  maxBreadcrumbs: 50,
  attachStacktrace: true,
  environment: config.environment,
  dist: process.env.CI_BUILD_NUMBER ?? undefined,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: [
    'localhost',
    /^capacitor:\/\//,
    'capacitor://localhost',
    'http://localhost:*',
    'https://localhost:*',
    'ionic://localhost',
    process?.env?.NEXT_PUBLIC_DOMAIN ?? '',
  ],
  beforeSend(event) {
    //ignore event ChunkLoadError error
    if (
      event?.exception?.values?.some(
        ({ value, type }) =>
          value === "Unexpected token '<'" || type === 'ChunkLoadError'
      )
    ) {
      return null
    }
    //ignore event FirebaseError auth/popup-blocked error
    if (
      event?.exception?.values?.some(
        ({ value, type }) =>
          value === 'Firebase: Error (auth/popup-blocked).' &&
          type === 'FirebaseError'
      )
    ) {
      return null
    }
    //ignore event FirebaseError auth/network-request-failed error
    if (
      event?.exception?.values?.some(
        ({ value, type }) =>
          value === 'Firebase: Error (auth/network-request-failed).' &&
          type === 'FirebaseError'
      )
    ) {
      return null
    }
    return event
  },
}

if (process.env.NODE_ENV !== 'production') {
  sentryOptions.debug = true
}

Sentry.init(sentryOptions)
Sentry.setTag('application', packageJson?.name)
Sentry.setTag('applicationKey', config?.applicationKey)
